import { render } from "./SearchQuotes.vue?vue&type=template&id=01506472"
import script from "./SearchQuotes.vue?vue&type=script&lang=js"
export * from "./SearchQuotes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__